import React from 'react';
import { Card } from '~/pistonSalsita';

export const CatalogueLoadingSkeleton = () => (
  <div className="CardWrapper loading">
    <div className="CardLink">
      <Card>
        <Card.Course />
      </Card>
    </div>
    <div className="CardLink">
      <Card>
        <Card.Course />
      </Card>
    </div>
    <div className="CardLink">
      <Card>
        <Card.Course />
      </Card>
    </div>
  </div>
);
